import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/profile/components/wrapper/inlearno/index.ts